var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderSmallWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    className: "uil-default",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    fill: "none",
    className: "bk"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(0 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(32.72727272727273 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.08290909090909092s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(65.45454545454545 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.16581818181818184s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(98.18181818181819 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.24872727272727274s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(130.9090909090909 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.3316363636363637s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(163.63636363636363 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.4145454545454546s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(196.36363636363637 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.4974545454545455s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(229.0909090909091 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.5803636363636364s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(261.8181818181818 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.6632727272727273s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(294.54545454545456 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.7461818181818182s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 21,
    x: 44.5,
    y: 39.5,
    fill: "#F8F8F8",
    rx: 3,
    ry: 3,
    transform: "rotate(327.27272727272725 50 50) translate(0 -31)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.8290909090909092s",
    dur: "0.912s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSmallWhite);
export default __webpack_public_path__ + "static/media/LoaderSmallWhite.8502a9f7ec17dc25b46abd42ae40830d.svg";
export { ForwardRef as ReactComponent };